declare global {
    interface Navigator {
        msSaveBlob?: (blob: any, defaultName?: string) => boolean
    }
}
export class CsvService {
    public static csvToArray(text: string): string[][] {
        let row = [''];
        const dataArray = [row];
        let previous = '';
        let rowIndex = 0;
        let resultIndex = 0;
        let s = true;
        for (let currentChar of text) {
            if ('"' === currentChar) {
                if (s && currentChar === previous) {
                    row[rowIndex] += currentChar;
                }
                s = !s;
            } else if (',' === currentChar && s) {
                currentChar = row[++rowIndex] = '';
            } else if ('\n' === currentChar && s) {
                if ('\r' === previous) {
                    row[rowIndex] = row[rowIndex].slice(0, -1);
                }
                row = dataArray[++resultIndex] = [(currentChar = '')];
                rowIndex = 0;
            } else {
                row[rowIndex] += currentChar;
            }
            previous = currentChar;
        }

        if (dataArray.length > 1) {
            return dataArray.splice(1);
        } else {
            return [];
        }
    }
    public static exportResultsToCsv(filename: string, rows: string[][], columnNames: string[]): void {
        const csvContent = [columnNames]
            .concat(rows)
            .map((e) => e.join(','))
            .join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) {
            // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
                // feature detection
                // Browsers that support HTML5 download attribute
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
}
